import "./App.css";
import { Login } from "./pages/Login/Login";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import Page1 from "./pages/Page1/Page1";
import Page2 from "./pages/Page2/Page2";
import Page3Office from "./pages/Page3Office/Page3Office";
import Page3Residence from "./pages/Page3Residence/Page3Residence";
import Page3ResiCumBusiness from "./pages/Page3ResiCumBusiness/Page3ResiCumBusiness";
import Page4 from "./pages/Page4/Page4";
import Page5 from "./pages/Page5/Page5";
import CreateUser from "./pages/CreateUser/CreateUser";
import EditUser from "./pages/EditUser/EditUser";

export const url = "https://cpvapi.credin.in";
// export const url = `http://localhost:3000`;

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/1" element={<Page1 />} />
          <Route path="/2" element={<Page2 />} />
          <Route path="/3office" element={<Page3Office />} />
          <Route path="/3residence" element={<Page3Residence />} />
          <Route path="/3resi-cum-business" element={<Page3ResiCumBusiness/>} />
          <Route path="/4" element={<Page4 />} />
          <Route path="/5" element={<Page5 />} />
          <Route path="/create" element={<CreateUser />} />
          <Route path="/edit" element={<EditUser />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
